<div class="modal-header">
    <span *ngIf="!referenceId" class="modal-header-title">{{ 'DIALOG.REFERENCES.ADD_DIRECTORY' | translate }}</span>
    <span *ngIf="referenceId"  class="modal-header-title">{{ 'DIALOG.REFERENCES.EDIT_DIRECTORY' | translate }}</span>
    <div class="tool">
        <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
            <span aria-hidden="true">&times;</span>
        </button> -->
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
            <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
        </button>
   </div>
</div>
<div class="modal-body">

    <div class="serchForm row mb-3">

        <div class="input-group col-7">

            <input type="text" class="form-control" placeholder="Поиск по элементам справочника" [(ngModel)]="search" aria-describedby="btnGroupSearch">

            <button *ngIf="search" class="btn btn-outline-secondary" type="button" (click)="clearingSearch()" placement="top" ngbTooltip="{{ 'CLEAR' | translate }}">
                <i class="bi bi-x"></i>
            </button>

            <button class="btn btn-light btn-search" [disabled]="!searchResult" (click)="searchReferencesElement()" ngbTooltip="{{ 'SEARCH' | translate }}">
                <i class="bi bi-search"></i>
            </button>
            
        </div>
    </div>

        <form class="form" [formGroup]="form" autocomplete="off">

            <div class="row">

                <!-- <div class="col-12" *ngIf="(!referenceId || (editData && referenceId))">

                    <div *ngIf="permissionAccess.check('REFERENCES_ORGANIZATIONS') && (!referenceId || (editData.org_id && referenceId))">
                        <div class="form-group">
                            <label class="filter-label" for="org_id"> {{ 'ORGANIZATION.NAME' | translate }}:</label>
                            <ng-select 
                            id="org_id" 
                            class="custom" 
                            clearAllText="{{ 'CLEAR' | translate }}"
                            notFoundText="{{ 'NO_DATA' | translate }}" 
                            bindLabel="name" 
                            bindValue="id"
                            formControlName="org_id"
                            (search)="getOrganizations($event.term)"
                            placeholder="{{ 'REFERENCE.SELECT_ORGANIZATION' | translate }}"
                            [multiple]="false" 
                            [items]="organizations">
                            </ng-select>
                        </div>
                    </div>

                </div> -->

                <div class="col-12">
                    <ff-input-lang
                        label="{{ 'DIALOG.REFERENCES.NAME_DIRECTORY' | translate }}"
                        hint="{{ 'DIALOG.REFERENCES.NAME_DIRECTORY_ALL_LANGUAGE' | translate }}"
                        fieldId="name"
                        fieldName="name"
                        fieldType="text"
                        [clearField]="ffInputLangParams.name.clearField"
                        [required]="ffInputLangParams.name.required"
                        [inputValue]="referenceName"
                        (changeValue)="eventFnFF('name', $event)">
                    </ff-input-lang>
                </div>

            </div>

        <!-- </form> -->





        <!-- <form class="form" [formGroup]="form" autocomplete="off"> -->

        <div class="reference-edge form-group" *ngIf="form.get('data')['controls'].length > 0">
             <label for="service-title" class="filter-label"><span> {{ 'DIALOG.REFERENCES.ELEMENT_DIRECTORY' | translate }}: </span></label>
        </div>
            <div formArrayName="data" class="ref-child-data">

                <div *ngFor="let item of form.get('data')['controls']; let i = index;">

                    <div class="row row-data mt-4" [formGroupName]="i">

                        <div class="col-3">
                            <div class="form-group">
                                <label class="filter-label" for="id_{{i}}" class="label"><span class="star">*</span> {{ 'DIALOG.REFERENCES.ID' | translate }}:</label>
                                <input type="text" class="form-control" id="id_{{i}}" formControlName="id" >
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.id">
                                        <div class="text-error" *ngIf="validation(['data', i, 'id'], item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-8">
                            <ff-input-lang
                                #element
                                label="{{ 'DENOMINATION' | translate }}"
                                hint="{{ 'DIALOG.REFERENCES.NAME_ELEMENT_DIRECTORY' | translate }}"
                                fieldId="name"
                                fieldName="name"
                                fieldType="text"
                                [clearField]="ffInputLangParams.name.clearField"
                                [required]="ffInputLangParams.name.required"
                                [inputValue]="referenceElementName[i]"
                                (changeValue)="eventArrayFnFF(i, 'name', $event)">
                            </ff-input-lang>
                        </div>

                        <div class="col-1">
                            <div class="remove-reference-field">
                                <button type="button" class="btn btn-danger" (click)="referencesControlDelete(i)"> 
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="data-loading" *ngIf="referenceId != '' && editData.data == null"> 
                <div *ngIf="loading" class="data-loading" colspan="3">
                    <div> {{ 'LOADING' | translate }} </div>
                </div>
                <div *ngIf="!loading" class="data-not-found" colspan="3">
                    <div> {{ 'DATA_NOT_FOUND' | translate }} </div>
                </div>
            </div>
   
        <div class="row">
            <div class="col-12">
                <div class="add-reference-field">
                    <button type="button" class="btn btn-primary btn-sm" (click)="addReferenceFields()"> 
                        <i class="bi bi-plus-circle"></i> {{ 'DIALOG.REFERENCES.ADD_ELEMENT_DIRECTORY' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="row">
    <div class="col-12">
        <div class="card-footer mt-2">
            <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
        </div>
    </div>
    <div class="col-12">
        <div class="modal-footer btn-box">
            <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
            <button *ngIf="!referenceId" type="button" class="btn btn-primary btn-sm" (click)="onCreate()" [disabled]="form.invalid || !ffInputLang.valid || form.get('data')['controls'].length == 0">{{ 'SAVE'| translate}}</button>
            <button *ngIf="referenceId"  type="button" class="btn btn-primary btn-sm" (click)="onUpdate()" [disabled]="form.invalid || !ffInputLang.valid || form.get('data')['controls'].length == 0">{{ 'SAVE'| translate}}</button>
        </div>
    </div>
</div>